module.exports = __webpack_public_path__ + "static/media/exchange-dark.2f58fc8b.svg";